// Advanced phonic sound guide — one-syllable mnemonic word per letter that
// cleanly demonstrates the letter's most common phoneme. Different from the
// basic AZSounds (which uses generic example words like "apple/ball") — this
// list is tuned for teen/adult learners revisiting phonics fundamentals.
// e.g. H → "Her" so the /h/ sound leads the word.
export const PHONIC_GUIDE = [
  { letter: "A", mnemonic: "Ant", sound: "a" },
  { letter: "B", mnemonic: "Bat", sound: "b" },
  { letter: "C", mnemonic: "Cat", sound: "k" },
  { letter: "D", mnemonic: "Dog", sound: "d" },
  { letter: "E", mnemonic: "Egg", sound: "e" },
  { letter: "F", mnemonic: "Fun", sound: "f" },
  { letter: "G", mnemonic: "Go", sound: "g" },
  { letter: "H", mnemonic: "Her", sound: "h" },
  { letter: "I", mnemonic: "It", sound: "i" },
  { letter: "J", mnemonic: "Jam", sound: "j" },
  { letter: "K", mnemonic: "Kit", sound: "k" },
  { letter: "L", mnemonic: "Log", sound: "l" },
  { letter: "M", mnemonic: "Mom", sound: "m" },
  { letter: "N", mnemonic: "No", sound: "n" },
  { letter: "O", mnemonic: "Odd", sound: "o" },
  { letter: "P", mnemonic: "Pop", sound: "p" },
  { letter: "Q", mnemonic: "Quiz", sound: "kw" },
  { letter: "R", mnemonic: "Run", sound: "r" },
  { letter: "S", mnemonic: "Sit", sound: "s" },
  { letter: "T", mnemonic: "Top", sound: "t" },
  { letter: "U", mnemonic: "Up", sound: "u" },
  { letter: "V", mnemonic: "Van", sound: "v" },
  { letter: "W", mnemonic: "We", sound: "w" },
  { letter: "X", mnemonic: "Box", sound: "ks" },
  { letter: "Y", mnemonic: "Yes", sound: "y" },
  { letter: "Z", mnemonic: "Zip", sound: "z" },
];
